module.exports = __webpack_public_path__ + "media/images/athletes/3429-a675ea79e7a422e88c86b0ac6dad846f.png";